import React from 'react';
import { AppToast } from "../components/AppFeedback";

const CustomSnackbar = ({ open, message, severity = 'info', onClose, autoHideDuration = 3000 }) => {
  return (
    <AppToast
      open={open}
      message={message}
      severity={severity}
      onClose={onClose}
      autoHideDuration={autoHideDuration}
    />
  );
};

/*

  import CustomSnackbar from './CustomSnackbar';

  const [snackbarOpen1, setSnackbarOpen1] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    setSnackbarMessage('Project list fetcted !');
    setSnackbarSeverity('success');
    setSnackbarOpen1(true);


      // add at the end of each page
           <CustomSnackbar
              open={snackbarOpen1}
              message={snackbarMessage}
              severity={snackbarSeverity}
              autoHideDuration={2000} // 5 seconds
              onClose={() => setSnackbarOpen1(false)}
            />

COLORS
"success" ? Green
"error"   ? Red
"warning" ? Orange/Amber
"info"    ? Blue

*/

export default CustomSnackbar;
